document.querySelectorAll('.image-block__edit-hotspot').forEach(hotspot => {
  hotspot.addEventListener('click', (e) => {
    e.preventDefault();
    
    const triggerId = hotspot.dataset.hotspotTrigger;
    const imageBlock = hotspot.closest('.image-edit-block');
    const content = imageBlock?.querySelector(`[data-hotspot-content="${triggerId}"]`);
    const defaultOverlay = imageBlock?.querySelector('[data-hotspot-content="default"]');
    const isActive = hotspot.classList.contains('is-active');
    
    // Reset all hotspots and content within this image block
    imageBlock?.querySelectorAll('.image-block__edit-hotspot').forEach(h => h.classList.remove('is-active'));
    imageBlock?.querySelectorAll('.image-block__edit-hotspot-content').forEach(c => c.classList.remove('is-active'));
    
    if (!isActive && content) {
      // Show hotspot content, hide default
      hotspot.classList.add('is-active');
      content.classList.add('is-active');
      if (defaultOverlay) defaultOverlay.classList.remove('is-active');
    } else {
      // Show default overlay
      if (defaultOverlay) defaultOverlay.classList.add('is-active');
    }
  });
});

// Click outside returns to default overlay
document.addEventListener('click', (e) => {
  if (!e.target.closest('.image-block__edit-hotspot') && !e.target.closest('.image-block__image-overlay')) {
    document.querySelectorAll('.image-edit-block').forEach(imageBlock => {
      const defaultOverlay = imageBlock.querySelector('[data-hotspot-content="default"]');
      imageBlock.querySelectorAll('.image-block__edit-hotspot').forEach(h => h.classList.remove('is-active'));
      imageBlock.querySelectorAll('.image-block__edit-hotspot-content').forEach(c => c.classList.remove('is-active'));
      if (defaultOverlay) defaultOverlay.classList.add('is-active');
    });
  }
});
